import { IProduct } from "@Interfaces/Api/Product";
import Box from "@mui/material/Box";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  SearchBoxDropDown,
  SearchBoxDropDownInMobile,
  SearchIconWrapper,
  StyledDesktopSearch,
  StyledInputBase,
  StyledMobileSearch,
} from "@Styled/Layout/header";
import Image from "next/image";
import router from "next/router";
import SearchIcon from "@mui/icons-material/Search";
import { theme } from "@Definitions/Styled";

interface searchProps {
  allProducts: IProduct[];
  resetToDefault: Function;
  isSearchDropDownOpen: boolean;
  handleSearchTextChanged: Function;
  searchText: string;
  onHideInMobile?: Function;
  showMobileSearch: boolean;
}

function Search({
  allProducts,
  resetToDefault,
  isSearchDropDownOpen,
  handleSearchTextChanged,
  searchText,
  onHideInMobile,
  showMobileSearch,
}: searchProps) {
  return (
    <>
      {!showMobileSearch ? (
        <ClickAwayListener onClickAway={() => resetToDefault()}>
          <Box>
            <StyledDesktopSearch style={{ position: "relative" }}>
              <SearchIconWrapper>
                <SearchIcon style={{ color: theme.palette.primary.main }} />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ "aria-label": "search" }}
                value={searchText}
                onChange={(e) => handleSearchTextChanged(e.target.value)}
              />
            </StyledDesktopSearch>
            {isSearchDropDownOpen && (
              <SearchBoxDropDown sx={{ boxShadow: 2 }}>
                {allProducts &&
                  allProducts.map((item) => {
                    return (
                      <MenuItem
                        key={item._id}
                        value={item.name}
                        style={{
                          wordBreak: "break-all",
                          padding: "1rem",
                        }}
                      >
                        <ListItemIcon>
                          <Image
                            alt={item.name}
                            src={item.image.url}
                            width={40}
                            height={40}
                            loading="eager"
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={item.name}
                          style={{
                            textTransform: "capitalize",
                            marginLeft: "10px",
                            whiteSpace: "pre-wrap",
                          }}
                          onClick={() => {
                            {
                              router.push(`/products/${item.slug}`);
                            }
                            resetToDefault();
                            // setIsSearchDropDownOpen(false);
                            // setSearchText("");
                          }}
                        />
                        <br />
                      </MenuItem>
                    );
                  })}
              </SearchBoxDropDown>
            )}
          </Box>
        </ClickAwayListener>
      ) : (
        <ClickAwayListener onClickAway={() => onHideInMobile!()}>
          <Box>
            <StyledMobileSearch style={{ position: "relative" }}>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ "aria-label": "search" }}
                value={searchText}
                onChange={(e) => handleSearchTextChanged(e.target.value)}
              />
            </StyledMobileSearch>
            {isSearchDropDownOpen && (
              <SearchBoxDropDownInMobile sx={{ boxShadow: 1 }}>
                {allProducts &&
                  allProducts.map((item) => {
                    return (
                      <MenuItem
                        key={item._id}
                        value={item.name}
                        style={{
                          wordBreak: "break-all",
                          padding: "1rem",
                        }}
                      >
                        <ListItemIcon>
                          <Image
                            alt={item.name}
                            src={item.image.url}
                            width={40}
                            height={40}
                            loading="eager"
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={item.name}
                          style={{
                            textTransform: "capitalize",
                            marginLeft: "10px",
                            whiteSpace: "pre-wrap",
                          }}
                          onClick={() => {
                            {
                              router.push(`/products/${item.slug}`);
                            }
                            resetToDefault();
                            // setIsSearchDropDownOpen(false);
                            // setSearchText("");
                          }}
                        />
                        <br />
                      </MenuItem>
                    );
                  })}
              </SearchBoxDropDownInMobile>
            )}
          </Box>
        </ClickAwayListener>
      )}
    </>
  );
}
export default Search;
